import React from "react";
import { Stack, Typography, styled } from "@mui/material";
import { makeStyles } from "@mui/styles";

export interface IconValueVisualInterface {
  icon: string;
  value: string;
  type?: string;
  iconColor?: string;
  iconSize?: "sm" | "md" | "lg";
  variant?:
    | "button"
    | "caption"
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | "inherit"
    | "subtitle1"
    | "subtitle2"
    | "body1"
    | "body2"
    | "overline"
    | undefined;
  maxWidth?: number;
}
const useStyles = makeStyles((theme: any) => ({
  styledAnchor: {
    fontSize: "12px",
    fontWeight: 400,
    color: theme.palette.primary.main,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "fit-content",
    maxWidth: "115px",
    lineHeight: "1.5em",
    textDecoration: "underline"
  }
}));
const StyledText = styled(Typography)(() => ({
  fontWeight: 400,
  color: "#12121280",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  width: "fit-content",
  lineHeight: "1.5em"
}));

const IconValueVisual = ({
  icon,
  value,
  type,
  iconColor = "green",
  iconSize = "md",
  variant,
  maxWidth
}: IconValueVisualInterface) => {
  const classes = useStyles({});
  var link =
    "http://maps.google.com/maps?q=" +
    encodeURIComponent(value) +
    "zoom=14&amp;size=512x512&amp;maptype=roadmap&amp;sensor=false";
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <i className={`${icon} font-${iconColor} icon-${iconSize}`} />
      {type === "location"
        ? <a
            href={link}
            target="_blank"
            className={classes.styledAnchor}
            rel="noreferrer"
          >
            {value}
          </a>
        : <StyledText variant={variant || "h6"} maxWidth={maxWidth || 115}>
            {value}
          </StyledText>}
    </Stack>
  );
};
export default IconValueVisual;
